import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ReusableGoogleMapComponent } from '@app/components/reusable-google-map/reusable-google-map.component';
import { AuthServiceService } from '@app/services/auth-service.service';
import { DialogService } from '@app/services/dialog.service';
import { DriverService } from '@app/services/driver.service';
import { LoggingService } from '@app/services/logging.service';
import { ToastService } from '@app/services/toast.service';
import { ShareddtaService } from '@app/services/shareddta.service';
import { BreadcrumbService } from '@app/services/breadcrumb.service';
import { Subject, takeUntil } from 'rxjs';
export interface Driver {
  id: string;
  firstName: string;
  lastName: string;
  displayName: string;
  type: string;
  phone: string;
  email: string;
  address: string;
  avatar?: string;
  completionRate: number;
  joinedDate: Date;
  status: 'active' | 'inactive';
  location: {
    latitude: number;
    longitude: number;
  };
}

export interface DriverStats {
  todaysOrders: number;
  pending: number;
  successful: number;
  unsuccessful: number;
  cancelled: number;
}

export interface Document {
  id: string;
  name: string;
  type: 'pdf' | 'doc' | 'image';
  size: string;
  uploadedDate: Date;
}
interface NotificationItem {
  id: string;
  message: string;
  time: string;
  isUnread: boolean;
  hasImage?: boolean;
  imageUrl?: string;
  type: 'customer' | 'driver';
}

type StatFilter = 'today' | 'pending' | 'successful' | 'unsuccessful' | 'cancelled';
@Component({
  selector: 'app-driver-detail',
  templateUrl: './driver-detail.component.html',
  styleUrl: './driver-detail.component.scss'
})
export class DriverDetailComponent {
  private destroy$ = new Subject<void>();
  isLoading: boolean = false;

  // Driver data
  driver: any;

  // Stats data
  stats: DriverStats = {
    todaysOrders: 11,
    pending: 1,
    successful: 5,
    unsuccessful: 1,
    cancelled: 0
  };

  // Documents
  documents: any;
  notifications: NotificationItem[] = [
    {
      id: '1',
      message: 'Please be ready to pick the order - Packing slip attached',
      time: '26 seconds ago',
      isUnread: true,
      hasImage: true,
      imageUrl: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=600&h=400&fit=crop',
      type: 'customer'
    },
    {
      id: '2',
      message: 'Hello',
      time: '43 seconds ago',
      isUnread: true,
      hasImage: false,
      type: 'customer'
    },
    {
      id: '3',
      message: 'Your order #6252661 is out for delivery - Driver location shared',
      time: '2 hours ago',
      isUnread: false,
      hasImage: true,
      imageUrl: 'https://images.unsplash.com/photo-1524661135-423995f22d0b?w=600&h=400&fit=crop',
      type: 'customer'
    },
    {
      id: '4',
      message: 'Order #6252660 has been delivered successfully',
      time: '5 hours ago',
      isUnread: false,
      hasImage: false,
      type: 'customer'
    },
    {
      id: '5',
      message: 'Driver Sandeep has been assigned to order #6252662',
      time: 'Yesterday',
      isUnread: false,
      hasImage: false,
      type: 'customer'
    },
    {
      id: '6',
      message: 'Payment received for order #6252659',
      time: '2 days ago',
      isUnread: false,
      hasImage: false,
      type: 'customer'
    }
  ];

  // UI state
  activeFilter: StatFilter = 'today';
  mapEmbedUrl: string = '';
  isModalOpen: boolean = false;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public driverService: DriverService, public loggingService: LoggingService, private dialog: MatDialog, private toast: ToastService, private dialogService: DialogService, public authService: AuthServiceService, private shareddta: ShareddtaService,
    private breadcrumbService: BreadcrumbService
  ) { }
  driverId: any
  ngOnInit(): void {
    // Get driver ID from route params
    this.route.params.pipe(takeUntil(this.destroy$)).subscribe(params => {
      const driverId = params['id'];
      if (driverId) {
        this.getDriverDetails(driverId);
      }
      this.driverId = driverId;
    });

    // Generate map embed URL
    this.updateMapUrl();

    // Optional: Auto-refresh location every 30 seconds
    // interval(30000).pipe(takeUntil(this.destroy$)).subscribe(() => {
    //   this.refreshDriverLocation();
    // });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Load driver data from service
   */
  loadDriverData(driverId: string): void {
    // TODO: Replace with actual API call
    // this.driverService.getDriverById(driverId).subscribe(driver => {
    //   this.driver = driver;
    //   this.updateMapUrl();
    // });
    console.log('Loading driver:', driverId);
  }
  likePercentage: any;
  getDriverDetails(driverId: string | null) {
    this.isLoading = true;
    this.driverService.driverDetails(driverId).subscribe((res) => {
      if (res && res.result) {
        let driverDetails = res.result
        this.driver = driverDetails;
        this.likePercentage = this.calculateLikePercentage();

        // Set global breadcrumb with driver name
        const driverName = `${this.driver.first_name} ${this.driver.last_name}${this.driver.groups?.[0]?.id === 3 ? ' (HD)' : ''}`;
        this.breadcrumbService.set([
          { label: 'Drivers', icon: 'M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z', action: () => this.router.navigate(['/admin/driver']) },
          { label: driverName }
        ]);
        if (this.driver.certificate && this.driver.certificate.length > 0) {
          this.documents = this.driver.certificate.map((cert: any) => {
            return {
              id: cert.id,
              name: cert.doc_name,
              url: cert.image,
              type: this.getFileType(cert.image),
              size: '—'
            };
          });
        } else {
          this.documents = [];
        }
      }
      this.getDriverOrderCounts();
    }, (error) => {
      this.isLoading = false;
      this.shareddta.signalPageReady();
    });
  }
  getFileType(url: string): string {
    const ext = url.split('.').pop()?.toLowerCase();

    if (ext === 'pdf') return 'pdf';
    if (['jpg', 'jpeg', 'png', 'gif'].includes(ext || '')) return 'image';

    return 'doc';
  }


  formatDate(date: Date): string {
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }
  pendingOrderCount: number = 0;
  successfullOrderCount: number = 0;
  unSuccessfullOrderCount: number = 0;
  todayOrderCount: number = 0;
  cancelled: number = 0;
  getDriverOrderCounts() {
    let today_date = this.formatDate(new Date());
    this.driverService.orderCount(this.driverId, today_date).subscribe((data: any) => {
      let driverOrderCount = data?.result;
      if (driverOrderCount?.today_ordr_count_status?.length > 0) {
        driverOrderCount?.today_ordr_count_status.forEach((element: any) => {
          if (element.order_status == 'pending') {
            this.pendingOrderCount = element.count + this.pendingOrderCount;
          }
          else if (element.order_status == 'successful') {
            this.successfullOrderCount = element.count;
          } else if (element.order_status == 'unsuccessful') {
            this.unSuccessfullOrderCount = element.count;
          }
          else if (element.order_status == 'cancelled') {
            this.cancelled = element.count;
          }
        })
      }
      if (driverOrderCount?.today?.length > 0) {
        driverOrderCount?.today.forEach((element: any) => {
          this.todayOrderCount = this.todayOrderCount + element.count;
        })
      }
      this.isLoading = false;
      this.shareddta.signalPageReady();
    }, (error) => {
      this.isLoading = false;
      this.shareddta.signalPageReady();
    });
  }
  calculateLikePercentage() {
    const likeData = this.driver.like;

    // Calculate total likes (both true and false)
    const totalLikes = likeData.reduce((total: number, item: { count: number }) => total + item.count, 0);

    // Calculate the true likes (where is_like is true)
    const trueLikes = likeData
      .filter((item: { is_like: boolean }) => item.is_like)
      .reduce((total: number, item: { count: number }) => total + item.count, 0);

    // Calculate percentage and round it to two decimal places
    const percentage = totalLikes > 0 ? (trueLikes / totalLikes) * 100 : 0;

    // Return percentage with two decimal places and add the '%' sign
    return percentage.toFixed(2) + '%';
  }

  /**
   * Refresh driver's GPS location
   */
  refreshDriverLocation(): void {
    // TODO: Replace with actual API call
    // this.driverService.getDriverLocation(this.driver.id).subscribe(location => {
    //   this.driver.location = location;
    //   this.updateMapUrl();
    // });
    console.log('Refreshing location...');
  }

  /**
   * Generate Google Maps embed URL
   */
  updateMapUrl(): void {
    const { latitude, longitude } = this.driver.location;
    this.mapEmbedUrl = `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2886.234!2d${longitude}!3d${latitude}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2z${this.encodeCoordinates(latitude, longitude)}!5e0!3m2!1sen!2sca!4v${Date.now()}`;
  }

  /**
   * Encode coordinates for Google Maps URL
   */
  private encodeCoordinates(lat: number, lng: number): string {
    return encodeURIComponent(`${lat},${lng}`);
  }

  /**
   * Toggle driver status
   */
  toggleStatus(): void {
    this.driver.is_active = !this.driver.is_active;

    this.isActivate = this.driver.is_active ? 'true' : 'false';
    this.updateDriverStatus();
  }
  isActivate: any
  updateDriverStatus() {
    const previousStatus = !this.driver.is_active;
    var formdata = new FormData();
    formdata.append('status', this.driver.is_active ? 'true' : 'false');
    this.driverService.driverActivateDeactivate(this.driverId, formdata).subscribe((res) => {
      this.driverService.forceRefreshListing = true; // Refresh listing cache
      if (res.errorMessage) {
        this.driver.is_active = previousStatus;
        this.toast.show('error', res.errorMessage);
      }
      else {
        this.toast.show('success', res.resultDescription);;
      }
    }, (err) => {
      this.driver.is_active = previousStatus;
      this.toast.show('error', "Failed to update");
    })
  }
  /**
   * Filter stats by type
   */
  filterStats(type: StatFilter): void {
    this.activeFilter = type;
    localStorage.setItem('driveractiveFilter', this.activeFilter);
    this.router.navigate(['admin/driver/detail/orders', this.driver.id]);;

    // TODO: Load filtered orders
    // this.orderService.getDriverOrders(this.driver.id, type).subscribe(orders => {
    //   // Handle filtered orders
    // });
    console.log('Filter by:', type);
  }

  /**
   * Copy text to clipboard
   */
  copyToClipboard(text: string): void {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(() => {
        this.toast.show('success', ' Copied!');
        // TODO: Show toast notification
        // alert(`Copied to clipboard: ${text}`);
      }).catch(err => {
        console.error('Failed to copy:', err);
      });
    }
  }

  /**
   * Navigate back to drivers list
   */
  goToDrivers(): void {
    this.router.navigate(['admin/driver']);
  }

  /**
   * Edit driver
   */
  editDriver(): void {
    this.router.navigate(['admin/driver/edit', this.driver.id]);;
  }

  /**
   * Delete driver
   */
  async deleteDriver(): Promise<void> {
    const confirmed = await this.dialogService.confirm(
      'Delete Row',
      'Are you sure you want to delete this driver? This action cannot be undone.',
      'Delete',
      'Cancel'
    );

    if (confirmed?.confirmed) {
      // console.log("FormData Value:", formdata.get('order_ids'));
      this.driverService.driverDelete(this.driverId).subscribe(
        (data: any) => {
          if (this.authService.resultCodeError(data)) {
            return;
          }
          if (data.resultDescription) {
            this.driverService.forceRefreshListing = true; // Refresh listing cache
            this.toast.show('success', data.resultDescription);
            this.router.navigate(['/' + this.authService._isRoleName + '/driver']);
          }
        },
        (error: any) => {
          this.authService.dataError(error);
        }
      );
    }
  }

  /**
   * View recent notifications
   */
  viewNotifications(): void {
    this.router.navigate(['/drivers', this.driver.id, 'notifications']);
  }

  /**
   * Send notification to driver
   */
  sendNotificationToDriver(): void {
    // TODO: Open notification modal or navigate to send notification page
    // this.dialog.open(SendNotificationComponent, {
    //   data: { driverId: this.driver.id, driverName: this.driver.displayName }
    // });
    console.log('Send notification to:', this.driver.displayName);
    alert(`Send notification to ${this.driver.displayName}`);
  }

  /**
   * View document
   */
  viewDocument(document: any): void {
    if (document.url) {
      window.open(document.url, '_blank');
    } else {
      alert('Document URL not available');
    }
  }


  /**
   * Track driver (real-time tracking)
   */
  // trackDriver(): void {
  //   // TODO: Navigate to real-time tracking page
  //   this.router.navigate(['/tracking', this.driver.id]);
  // }
  title: string = 'Driver Details Component'
  trackDriver() {
    this.myFunction(this.title, 'trackDriver');
    let enterAnimationDuration = '200ms';
    let exitAnimationDuration = '200ms';

    const dialogRef = this.dialog.open(ReusableGoogleMapComponent, {
      width: '1100px',
      height: '90vh',
      enterAnimationDuration,
      exitAnimationDuration,
      data: {
        height: '100%',
        driverData: this.driver,
        isComponent: true,
        isDriverDetail: true,
        showHeader: true,
        customHeaderTitle: 'Track Driver'
      },
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {

      }
    });


  }
  myFunction(title: any, functionName: any) {
    try {
      throw new Error('GOOGLE API HIT');
    } catch (error: any) {
      // Handle the error gracefully
      this.loggingService.error(error.message, error, title, functionName);
      // You can also perform additional actions like logging or displaying a user-friendly error message
    }
  }
  /**
   * Get formatted joined date
   */
  getFormattedJoinedDate(): string {
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    }).format(this.driver.joinedDate);
  }

  /**
   * Get status display text
   */
  getStatusText(isActive: boolean): string {
    return isActive ? 'Active' : 'Inactive';
  }
  getDriverInitials(driver: any): string {
    if (!driver) return '';

    const firstInitial = driver.first_name
      ? driver.first_name.trim().charAt(0).toUpperCase()
      : '';

    const lastInitial = driver.last_name
      ? driver.last_name.trim().charAt(0).toUpperCase()
      : '';

    return [firstInitial, lastInitial].filter(Boolean).join(' ');
  }

  /**
   * Check if filter is active
   */
  isFilterActive(filter: StatFilter): boolean {
    return this.activeFilter === filter;
  }

  /**
   * Get document icon class
   */
  getDocumentIconClass(type: string): string {
    switch (type) {
      case 'pdf':
        return 'pdf';
      case 'image':
        return 'image';
      case 'doc':
      default:
        return 'doc';
    }
  }

  /**
   * TrackBy function for documents list
   */
  trackByDocId(index: number, document: Document): string {
    return document.id;
  }
  onBackdropClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('modal')) {
      this.closeModal();
    }
  }
  closeModal(): void {
    this.isModalOpen = false;
    this.showError = false;
    this.resetForm();
  }
  messageText: string = '';
  selectedFiles: File[] = [];
  filePreviews: { file: File; url: string }[] = [];
  charCount: number = 0;
  maxChars: number = 500;
  recipientType: 'customers' | 'drivers' | 'all' = 'drivers';
  resetForm(): void {
    this.messageText = '';
    this.selectedFiles = [];
    this.filePreviews = [];
    this.charCount = 0;
  }
  toggleRecipientType(type: 'customers' | 'drivers'): void {
    this.recipientType = type;
  }
  showError: boolean = false;
  sendNotification(): void {
    if (!this.messageText.trim()) {
      // alert('Please enter a message');
      this.showError = true;
      return;
    }
    this.showError = false;
    const recipient = this.recipientType === 'customers' ? 'Customers' : 'Drivers';

    console.log('Sending notification to:', recipient);
    console.log('Message:', this.messageText);
    console.log('Files:', this.selectedFiles.length);
    const formData = new FormData();
    formData.append('message', this.messageText);

    // send_to mapping
    const sendTo = this.recipientType === 'customers' ? 'Customer' : 'Driver';
    formData.append('send_to_group', sendTo);

    // images from your onFileSelect
    if (this.selectedFiles.length > 0) {
      this.selectedFiles.forEach((file: File) => {
        formData.append('notification_image', file, file.name);
      });
    }
    formData.append('title', 'Driver Notification');
    formData.append('send_to_user', this.driverId);

    this.driverService.sendNotificationToGroup(formData).subscribe((res: any) => {
      this.toast.show('success', res.resultDescription);
    }, (err: any) => {
      this.toast.show('error', 'Failed to Send Notification');
    })
    this.closeModal();
  }
  removeFile(index: number): void {
    this.selectedFiles.splice(index, 1);
    this.filePreviews.splice(index, 1);
  }
  onFileSelect(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const files = Array.from(input.files);

      files.forEach(file => {
        if (file.type.startsWith('image/')) {
          this.selectedFiles.push(file);

          const reader = new FileReader();
          reader.onload = (e: any) => {
            this.filePreviews.push({
              file: file,
              url: e.target.result
            });
          };
          reader.readAsDataURL(file);
        }
      });
    }
  }
  getCharCountClass(): string {
    if (this.charCount >= 450) return 'limit-danger';
    if (this.charCount >= 400) return 'limit-warning';
    return '';
  }
  updateCharCount(): void {
    this.charCount = this.messageText.length;
  }
  openModal(): void {
    this.isModalOpen = true;
    this.resetForm();
  }

  isNotificationPanelOpen = false;
  activeTab: 'RTH' | 'RN' = 'RN';
  filteredNotifications: any;
  customerUnreadCount = 2;
  driverUnreadCount = 0;
  closeNotifications(): void {
    this.isNotificationPanelOpen = false;
  }
  switchTab(tab: 'RTH' | 'RN'): void {
    this.activeTab = tab;
    if (this.activeTab == "RTH") {
      this.filteredNotifications = null;
      this.OpenTripHistory();
    }
    else {
      this.tripHistory = null;
      this.openNotifications()
    }
  }
  viewAllNotifications(): void {
    console.log('View all notifications for:', this.activeTab);
    if (this.activeTab == 'RTH') {
      this.OpenAllTripHistory();
    }
    else {
      this.openAllNotifications();
    }
    // Navigate to full notifications page
  }
  //   get filteredNotifications(): NotificationItem[] {
  //   return this.notifications.filter(n => n.type === this.activeTab);
  // }
  markAsRead(notification: NotificationItem): void {
    if (notification.isUnread) {
      notification.isUnread = false;

      // Update badge count
      if (notification.type === 'customer') {
        this.customerUnreadCount = Math.max(0, this.customerUnreadCount - 1);
      } else {
        this.driverUnreadCount = Math.max(0, this.driverUnreadCount - 1);
      }
    }
  }
  openNotifications(): void {
    this.isNotificationPanelOpen = true;
    this.driverService.orderNotification(this.driverId).subscribe((data: any) => {
      this.filteredNotifications = data?.result?.results;
    });
  }
  openAllNotifications(): void {
    this.isNotificationPanelOpen = true;
    this.driverService.orderNotificationAll(this.driverId).subscribe((data: any) => {
      this.filteredNotifications = data?.result?.results;
    });
  }
  tripHistory: any
  OpenTripHistory() {
    this.driverService.orderHistory(this.driverId).subscribe((data: any) => {
      this.tripHistory = data?.result?.results.map((trip: any) => ({
        ...trip,
        localDelyDate: this.convertUtcToLocalDate(trip.dely_date)  // Apply conversion here
      }));
    });
  }
  OpenAllTripHistory() {
    this.driverService.tripHistoryAll(this.driverId).subscribe((data: any) => {
      this.tripHistory = data?.result?.results.map((trip: any) => ({
        ...trip,
        localDelyDate: this.convertUtcToLocalDate(trip.dely_date)  // Apply conversion here
      }));
    });
  }
  convertUtcToLocalDate(utcTimestamp: string): string {
    // Remove 'Z' if it is present at the end of the timestamp
    if (utcTimestamp.endsWith('Z')) {
      utcTimestamp = utcTimestamp.slice(0, -1);
    }

    // Parse the UTC timestamp
    const utcDate = new Date(utcTimestamp);

    // Check for invalid date
    if (isNaN(utcDate.getTime())) {
      throw new Error("Invalid time value");
    }

    // Define options for formatting the date
    const options: Intl.DateTimeFormatOptions = {
      weekday: 'short',  // e.g., Fri
      year: 'numeric',   // e.g., 2024
      month: 'short',    // e.g., Jun
      day: '2-digit'     // e.g., 07
    };

    // Format the date to local time
    const formattedDate = new Intl.DateTimeFormat('en-US', options).format(utcDate);

    return formattedDate;
  }
  openImage(url: string) {
  window.open(url, '_blank');
}
}
